/**
 * Helper para convertir URLs de V1 a V3 en backoffice API
 * 
 * backofficeApi por defecto apunta a /api/v1
 * Esta función permite hacer peticiones a /api/v3
 */

/**
 * Convierte una URL de V1 a V3
 * backofficeApi tiene como baseURL /api/v1
 * Esta función sube un nivel (../) y luego agrega v3/
 * 
 * @param {string} url - URL que puede empezar con /v1/ o sin versión
 * @returns {string} - URL relativa que va de v1 a v3
 * 
 * @example
 * toV3('physical-orders') => '../v3/physical-orders'
 * toV3('/physical-orders') => '../v3/physical-orders'
 * toV3('v3/physical-orders') => '../v3/physical-orders'
 */
export function toV3(url) {
  // Eliminar la barra inicial si existe
  let cleanUrl = url.startsWith('/') ? url.substring(1) : url;
  
  // Eliminar /v1/ si existe
  if (cleanUrl.startsWith('v1/')) {
    cleanUrl = cleanUrl.substring(3);
  }
  
  // Eliminar /v3/ si ya existe para evitar duplicados
  if (cleanUrl.startsWith('v3/')) {
    cleanUrl = cleanUrl.substring(3);
  }
  
  // Retornar con ../ para subir un nivel desde /api/v1 a /api, luego agregar v3/
  return `../v3/${cleanUrl}`;
}

/**
 * Convierte una URL de V3 a V1
 * @param {string} url - URL que puede empezar con /v3/ o sin versión
 * @returns {string} - URL con /v1/
 */
export function toV1(url) {
  // Eliminar la barra inicial si existe
  let cleanUrl = url.startsWith('/') ? url.substring(1) : url;
  
  // Eliminar /v3/ si existe
  if (cleanUrl.startsWith('v3/')) {
    cleanUrl = cleanUrl.substring(3);
  }
  
  // Eliminar /v1/ si ya existe para evitar duplicados
  if (cleanUrl.startsWith('v1/')) {
    cleanUrl = cleanUrl.substring(3);
  }
  
  // Retornar con /v1/ al inicio
  return `/v1/${cleanUrl}`;
}

export default {
  toV3,
  toV1
};

